/** @jsxImportSource solid-js */
import { PrimaryButton } from "#palette/components/button.solid";

export function Step_0_NotListed(props: { reset: () => void }) {
  return (
    <>
      <h1 class="mb-3 mt-6 text-xl font-medium  text-brand-900 font-serif">
        We’re so sorry. But unfortunately you don’t have access to Callisto
        Vault yet.
      </h1>
      <p>
        Callisto Vault is only available to .edu email holders in the US at this
        time. However, we are working tirelessly to expand.
      </p>
      <p class="mt-2">
        <a href="https://www.projectcallisto.org/give">
          Check out ways you can help
        </a>
        .
      </p>
      <PrimaryButton
        class="mt-5"
        onClick={() => {
          props.reset();
        }}
      >
        Go back
      </PrimaryButton>
    </>
  );
}
